import React from "react";

export function Toggle({ checked, onChange, testid }: { checked: boolean; onChange: (v: boolean) => void; testid?: string }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      data-testid={testid}
      onClick={() => onChange(!checked)}
      className={`relative h-6 w-11 shrink-0 rounded-full transition-colors ${checked ? "bg-atlas-500" : "bg-white/10"}`}
    >
      <span className={`absolute top-0.5 h-5 w-5 rounded-full bg-white shadow transition-transform ${checked ? "translate-x-[22px]" : "translate-x-0.5"}`} />
    </button>
  );
}

export function usePref(key: string, def: boolean): [boolean, (v: boolean) => void] {
  const [v, setV] = React.useState<boolean>(() => {
    try { const s = localStorage.getItem(key); return s == null ? def : s === "1"; } catch { return def; }
  });
  const set = (nv: boolean) => { setV(nv); try { localStorage.setItem(key, nv ? "1" : "0"); } catch {} };
  return [v, set];
}
